import { render, staticRenderFns } from "./ItsRegistAttn.vue?vue&type=template&id=8e011072&scoped=true&"
import script from "./ItsRegistAttn.vue?vue&type=script&lang=js&"
export * from "./ItsRegistAttn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e011072",
  null
  
)

export default component.exports